const getMetaAttributeValue = require('@atlassiansox/experiment-common-core/lib/get-meta-attribute-value');

const startsWith = (string, search) => string.indexOf(search) === 0;
/**
 * Return information about the current context.
 *
 * Everything here needs to be calculated without the presence of <body>.
 *
 * This function should make a best effort to gracefully fail.
 */
const CloudContext = function (hostname = window.location.hostname, pathname = window.location.pathname) {
  const PRODUCT_JIRA = 'jira';
  const PRODUCT_CONFLUENCE = 'confluence';
  const PRODUCT_CROWD = 'crowd';
  const PRODUCT_BITBUCKET = 'bitbucket';

  let product = 'unknown';
  let user;
  let cloudBaseUrl;
  try {
    if (getMetaAttributeValue('application-name', 'data-name') === 'jira') {
      product = PRODUCT_JIRA;
      user = getMetaAttributeValue('ajs-remote-user', 'content');
      cloudBaseUrl = '';
    } else if (getMetaAttributeValue('confluence-base-url', 'content') || startsWith(pathname, '/wiki')) {
      product = PRODUCT_CONFLUENCE;
      user = getMetaAttributeValue('ajs-remote-user', 'content');
      cloudBaseUrl = getMetaAttributeValue('confluence-base-url', 'content') || '/wiki';
    } else if (startsWith(pathname, '/admin')) {
      product = PRODUCT_CROWD;
      user = getMetaAttributeValue('remote-username', 'content');
    } else if (getMetaAttributeValue('bb-bootstrap', 'data-current-user')) {
      let bbBootstrap = JSON.parse(getMetaAttributeValue('bb-bootstrap', 'data-current-user'));
      product = PRODUCT_BITBUCKET;
      hostname = 'production';
      user = bbBootstrap.id;
    }
  } catch (e) {
    // silence
  }
  return {user, product, group: hostname, cloudBaseUrl};
};

module.exports = CloudContext;


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-cloud-core/lib/cloud-context.js